import CoreStyleLoader from 'core/editor/helpers/style-loader'

class StyleLoader extends CoreStyleLoader { }
export default StyleLoader
